//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdmSpisovyPlanStrediskoSpisovychUzluDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      FFIALA                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-03-12                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.1
//AdtGeneratorConfig:[ T:(sslvspl) GID:(Web.Set.Des.Ts) V1:(poznamka,aktivita,dat_zmena,zmenu_prov) V2:(aktivita) K1:(f_sslvspl_ixs_tre,f_sslvspl_spis_pl) K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdmSpisovyPlanStrediskoSpisovychUzluDesigner
     * 
     * @author FFIALA
     * @since 482.1.0.119
     */
    export class SeznamAdmSpisovyPlanStrediskoSpisovychUzluDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - ixs_tre */
            public ixs_tre: string;
            /** PK - spis_pl */
            public spis_pl: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdmSpisovyPlanStrediskoSpisovychUzluListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdmSpisovyPlanStrediskoSpisovychUzluDesigner>, ixs_tre: string, spis_pl: string): JQuery<HTMLElement> {

            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, ixs_tre, spis_pl);

            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction );

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdmSpisovyPlanStrediskoSpisovychUzluDesigner>, ixs_tre: string,spis_pl: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka
            v_filterForm
                .addRow({
                    label: "jres:29931723" //RC 29931723 : St�edisko spisov�ch uzl�
                })
                .addField("gselectbox", Gordic.Prefabs.Select.ginstre(), {
                    initialValue: { ixs_tre: that.ixs_tre || "" }, 
                    dropdown: false,
                    name: "ixs_tre", 
                    model: "model.ixs_tre=value.ixs_tre", 
                    disabled: true
                });

            v_filterForm
                .addRow({
                    label: "jres:30011365" //RC 30011365 : Spisov� pl�n
                })
                .addField("gselectbox", Gordic.Prefabs.Select.admsslsspl(), {
                    initialValue: { spis_pl: that.spis_pl || "" }, 
                    dropdown: false,
                    name: "spis_pl", 
                    model: "model.spis_pl=value.spis_pl", 
                    disabled: (spis_pl) ? true : false,
                });

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdmSpisovyPlanStrediskoSpisovychUzluDesigner>, ev, ctx): any {
            var filterObj = {
                ixs_tre: SeznamBase.filterContains(ctx.filter, "ixs_tre"),
                spis_pl: SeznamBase.filterContains(ctx.filter, "spis_pl")
            }
            that.view = new Gordic.Isl.View(that.isl.AdmSpisovyPlanStrediskoSpisovychUzlu.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdmSpisovyPlanStrediskoSpisovychUzluDesignerInit
         * 
         * @param {GContentType<SeznamAdmSpisovyPlanStrediskoSpisovychUzluDesigner>} that
         */
        static SeznamAdmSpisovyPlanStrediskoSpisovychUzluDesignerInit(that: GContentType<SeznamAdmSpisovyPlanStrediskoSpisovychUzluDesigner>, ixs_tre: string,spis_pl: string ) {

            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, ixs_tre,spis_pl);

            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);

            var filterObj: any = {}
            if (ixs_tre) {
                new Gordic.Data.Readers.Ginstre().getData({ ixs_tre: ixs_tre }).done((o) => {
                    that.filter.findFields("ixs_tre").gfield("setValue", o[0]);
                })
                filterObj.ixs_tre = ixs_tre;
            }
            if (spis_pl) {
                new Gordic.Data.Readers.AdmSslsspl().getData({ spis_pl: spis_pl }).done((o) => {
                    that.filter.findFields("spis_pl").gfield("setValue", o[0]);
                })
                filterObj.spis_pl = spis_pl;
            }
            that.view = new Gordic.Isl.View(that.isl.AdmSpisovyPlanStrediskoSpisovychUzlu.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem

        } // SeznamAdmSpisovyPlanStrediskoSpisovychUzluDesignerInit

    }
}
